<template>
    <div>
        <breadCrumb 
            :icon="'fa-user-lock'"
            :category="$t(`sideNav.navSalonSetting`)"
            :subCategory="$t(`subMenu.salon_setting_security`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 pb-4">
                    <div class="row w-100">
                        <div class="col-sm-12 col-md-4"> 
                            <div class="form-group d-flex">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                        <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                       <ul class="nav nav-tabs mb-5" role="tablist">
                            <li class="nav-item" v-for="securityTab in $i18n.messages[$i18n.locale].tab.securityTabs" :key="securityTab.id">
                                <a :class="{'active': selectedTab == securityTab.id}" class="nav-link" role="tab" @click="selectedTab = securityTab.id">{{securityTab.text}}</a>
                            </li>
                        </ul> 
                        <div class="tab-content mt-5">
                            <authorization ref="authorization" :class="{'active': selectedTab == 'authorize'}" :authorization="authorization" @submitEdit="editSecuritySettings" class="tab-pane"></authorization>
                            <permission :class="{'active': selectedTab == 'permission'}" :permissionType="permissionType" :permission="permission" @submitEdit="editSecuritySettings" class="tab-pane"></permission>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import Authorization from './Security_Authorization'
import Permission from './Security_Permission'

export default {
    name: 'securitySetting',
    components: {
        Authorization, Permission, BreadCrumb
    },
    data(){
        return{
            outlet: [], selectedOutlet: {},
            selectedTab: {},
            data: [], authorization: [], permission: [], permissionType: []
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                if(this.selectedTab == "authorize") document.getElementById('contact').focus();
                this.selectedTab = "authorize";
                this.getSecuritySetting()
                this.$refs.authorization.$refs.deleteModal.toggleModal = false
            }
            this.$parent.isModalShow = false
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.getSecuritySetting();
        },
        editSecuritySettings(item){
            if(this.selectedTab == "authorize") document.getElementById('contact').focus();

            let $vm = this;
            const url = this.$api.OUTLET + "/" + this.selectedOutlet.id + this.$api.SECURITY;

            Object.keys(this.data).forEach(function(key){  
                if(Object.keys(item)[0] == key){
                    $vm.data[key] = item[key]
                } 
            })

            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: this.data
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t(`subMenu.salon_setting_security`) + $vm.$i18n.t('message.success.update')
                    $vm.$parent.setModal($vm, false, true, message)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();
                }
            })
        },
        getSecuritySetting(){
            let $vm = this
            $vm.permissionType = []
            const url = $vm.$api.OUTLET + "/" + $vm.selectedOutlet.id + $vm.$api.SECURITY

            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.data = response.data;
                $vm.authorization = $vm.data.authorize;
                $vm.permission = $vm.data.permission;
                
                var permissionType = response.data.permissionType
                for(var i=0; i<permissionType.length; i++){
                    if(permissionType[i].permissionID != 1 && permissionType[i].permissionID != 5){
                        $vm.permissionType.push(permissionType[i])
                    }
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        }
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        $vm.selectedTab = $vm.$i18n.messages[$vm.$i18n.locale].tab.securityTabs[0].id
        $vm.getSecuritySetting();
    }

}
</script>

<style scoped>
.nav-link{
    cursor: pointer;
}
.show{
    display: block;
}
</style>